// src/components/CustomerView/sections/FinalConsumerView.tsx
import React from 'react';
import InfoField from '../../../Shared/InfoField';
import DocumentIdentificationField from '../fields/DocumentIdentificationField';
import { ICustomerDetail } from '../../../../types/customer/customerInterfaces';

interface Props {
  detail: ICustomerDetail;
}

const FinalConsumerView: React.FC<Props> = ({ detail }) => {
  return (
    <>
      {/* Datos Generales */}
      <section className="mb-8">
        <h3 className="text-gray-700 mb-4 text-lg font-semibold dark:text-white">
          Datos Generales
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <InfoField label="Nombre" value={detail.name} />
          <DocumentIdentificationField detail={detail} />
          <InfoField label="Teléfono" value={detail.phone} />
          <InfoField label="Correo" value={detail.email} />
        </div>
      </section>

      {/* Dirección */}
      <section>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <InfoField label="País" value={detail.countryName} />
          <InfoField label="Departamento" value={detail.departmentName} />
          <InfoField label="Municipio" value={detail.municipalityName} />
        </div>
        <div className="mt-4">
          <InfoField label="Complemento" value={detail.complement} />
        </div>
      </section>
    </>
  );
};

export default FinalConsumerView;
